import * as React from 'react';
import { useGateApi } from '../Api/useGateApi';
import { ApiException, AuthGateApiClient, AuthMicrosoftRequest, SignupMicrosoftRequest, SignupUserMicrosoftRequest, StorePluginSessionTokensRequest } from '../Api/ApiServerHooks';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { AccountInfo, AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { useNavigate, useParams } from 'react-router';
import { Alert, AlertTitle, Box, Button, CircularProgress, Snackbar, Typography } from '@mui/material';
import ChooseTenantDialog from './ChooseTenantDialog';
import { acquireMicrosoftTokenSilent, getMicrosoftLoginAccount, getMicrosoftLoginPage, microsoftAccountKindKey, microsoftLoginSucceeded, microsoftTokenAcquired, renewMicrosoftAccount, signOutMicrosoftAccount, startMicrosoftLogin } from './MicrosoftAccount';
import { useGateMainContext } from '../GateMainContext';
import { useTranslation } from 'react-i18next';

export interface IRedirectHandlerProps {
}

export default function RedirectHandler(props: IRedirectHandlerProps) {
    const { instance, accounts, inProgress } = useMsal();
    const navigate = useNavigate();
    const { login } = useGateMainContext();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [userId, setUserId] = React.useState<number>(0);
    const [state, setState] = React.useState<{ name: string, tenant: string } | undefined>();
    const [loginError, setLoginError] = React.useState("");
    const [accessTokenMS, setAccessTokenMS] = React.useState<string>();
    const [msAccount, setMsAccount] = React.useState<AccountInfo>();
    const [loginFailure, setLoginFailure] = React.useState<{ account: AccountInfo, notRegistered: boolean, detail?: string }>();
    const [switchingAccount, setSwitchingAccount] = React.useState(false);
    const { t, i18n } = useTranslation();
    const params = useParams();
    const isAuth = useIsAuthenticated();
    // React.useEffect(() => {
    //     instance.handleRedirectPromise();
    // }, [instance]);

    const handleRedirect = async () => {
        // A failed login stays on its panel - signing the account out from there must not
        // start the login again on its own.
        if (loginFailure)
            return;
        // Only once MSAL has settled: with the account already cached, every status on the way
        // (handleRedirect, none) would otherwise log in again.
        if (isAuth && inProgress === InteractionStatus.None) {
            const account = getMicrosoftLoginAccount(accounts);
            if (account) {
                // User is logged in, you can now acquire tokens
                let accessTokenResponse: AuthenticationResult;
                try {
                    accessTokenResponse = await acquireMicrosoftTokenSilent(instance, account);
                }
                catch (e) {
                    // The cached account outlived its tokens, whatever the error says - Microsoft
                    // signs it in again. Only when that does not help is it a failed login.
                    console.error(e);
                    const renewing = await renewMicrosoftAccount(instance, account).catch((renewalError) => {
                        console.error(renewalError);
                        return false;
                    });
                    if (!renewing)
                        setLoginFailure({ account: account, notRegistered: false, detail: (e as { errorCode?: string })?.errorCode });
                    return;
                }
                microsoftTokenAcquired();
                // console.log(accessTokenResponse);
                setAccessTokenMS(accessTokenResponse.accessToken);
                setMsAccount(account);
                let redirectPath = localStorage.getItem('ms-redirect');
                let msState = localStorage.getItem('ms-state');
                // if (inProgress) {
                if (redirectPath !== null || msState !== null) {
                    console.log('redirecting to', redirectPath);
                    loginMS(accessTokenResponse.accessToken, account, undefined, redirectPath ? redirectPath : undefined);
                    // localStorage.removeItem('ms-redirect');
                    // navigate(redirectPath);
                }
                else { console.log('cesta 2', msState); navigate('/portal'); }
                // }
                // Now you have the access token, you can use it for API calls
            }
        }


        if (window.location.hash === '') {

            if (inProgress && inProgress === 'none' && !isAuth) {
                // instance.bro[   "browserStorage"].clear();
                instance.handleRedirectPromise().then(async (authResult) => {
                    // Check if user signed in 
                    // console.log('inProgress', inProgress, authResult?.accessToken);
                    const accounts = instance.getAllAccounts();
                    if (accounts.length === 0) {

                        await startMicrosoftLogin(instance);
                    }
                    // 
                }).catch(err => {
                    // TODO: Handle errors
                    console.log(err);
                });
                // await msal.instance.initialize();
            }
            else if (params['hash'] !== undefined) {
                const url = window.location.href;
                localStorage.setItem('ms-redirect', '/' + params['hash']);
                window.location.href = window.location.protocol + '//' + window.location.host + '/auth-callback';
            }
            // else 

        }

    };
    React.useEffect(() => {
        handleRedirect();
    }, [isAuth, instance, inProgress]);
    const { unauthorizedApi, authorizedApi } = useGateApi(AuthGateApiClient);
    const loginMS = async (accessToken: string, account: AccountInfo, tenantId: number | undefined, state: string | undefined) => {

        // Read the whole login context up front. Everything below happens after an awaited
        // API call, and an expired session being cleaned up in parallel must not be able to
        // change what this login does half way through.
        var type = localStorage.getItem('ms-state');
        const isToolLogin = localStorage.getItem('tool-login') === 'true';
        const storedRedirect = localStorage.getItem('ms-redirect');
        const redirectServer = localStorage.getItem('redirect-server');
        console.log('loginMS', type, tenantId, state);
        if (type === 'login') {
            unauthorizedApi.authMicrosoft(new AuthMicrosoftRequest({ tenantId: tenantId, token: accessToken })).then((v) => {
                microsoftLoginSucceeded();
                localStorage.setItem('token', v.token!);

                localStorage.setItem('token_expires', v.tokenExpiration?.toString()!);
                localStorage.setItem('refresh_token', v.refreshToken!);
                if (isToolLogin) {
                    localStorage.removeItem('tool-login');
                    authorizedApi?.storePluginLoginSessionTokens(new StorePluginSessionTokensRequest({
                        accessToken: v.token!,
                        refreshToken: v.refreshToken!,
                        expires: v.tokenExpiration!
                    })).then((session) => {

                        // console.log('http://localhost:3001/gateredirect/' + encodeURIComponent(localStorage.getItem('ms-redirect')!) + '/' + session.sessionId);
                        window.location.href = redirectServer + '/gateredirect/' + encodeURIComponent(storedRedirect ?? '/') + '/' + i18n.language + '/' + session.sessionId;

                    }).catch(() => {
                        // Without a plugin session there is nothing to hand back to the tool -
                        // say so instead of leaving the user on a spinner.
                        setLoginError('Chyba, kontaktujte podporu');
                    })
                }
                else if (v.id && v.tenantId && v.tenantId) {
                    login(v);
                    if (storedRedirect) {
                        navigate(storedRedirect);
                    }
                    else
                        navigate('/portal');
                }
                else if ((v.tenantId === null || v.tenantId === undefined) && v.id) {
                    console.log(state);
                    localStorage.setItem('temp_tenant_token', v.token!);
                    // setState(state ? JSON.parse(state) : undefined);
                    setUserId(v.id);
                    setDialogOpen(true);
                }

            }).catch((e: ApiException) => {
                // The server answers 400 with no body when no identity matches the Microsoft
                // account. With a tenant chosen, it can also mean the identity is not in it.
                const notRegistered = e?.status === 400 && tenantId === undefined;
                setLoginFailure({ account: account, notRegistered: notRegistered, detail: notRegistered || !e?.status ? undefined : 'HTTP ' + e.status });
            });
        }
        else if (type === 'user-signup-microsoft') {
            let userId = parseInt(localStorage.getItem('ms-signup-userid')!);
            let signupToken = localStorage.getItem('ms-signup-token');

            unauthorizedApi.signupUserMicrosoft(new SignupUserMicrosoftRequest({ msToken: accessToken, userId: userId, signupToken: signupToken ?? undefined })).then((res) => {
                if (res && res.ok) {
                    localStorage.removeItem('ms-signup-userid');
                    localStorage.removeItem('ms-signup-token');
                    navigate('/');
                }
                else
                    setLoginError('Chyba, kontaktujte podporu');
            });
        }

        else if (type !== null) {
            unauthorizedApi.signupMicrosoft(new SignupMicrosoftRequest({ tenant: type, token: accessToken })).then((v) => {
                if (v.microsoftId !== undefined && state) {
                    navigate(state);
                    //navigate('/projects');
                }
            }).catch((e) => { setLoginError('Chyba'); });
        }
    }

    const signInWithAnotherAccount = async () => {
        setSwitchingAccount(true);
        try {
            await signOutMicrosoftAccount(instance, loginFailure!.account);
            await startMicrosoftLogin(instance);
        }
        catch (e) {
            console.log(e);
            setSwitchingAccount(false);
        }
    }

    if (loginFailure) {
        const values = { account: loginFailure.account.username, kind: t(microsoftAccountKindKey(loginFailure.account)) };
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', padding: '16px', marginTop: '10vh' }}>
                <Box sx={{ width: '100%', maxWidth: '480px' }}>
                    <Alert severity='error'>
                        <AlertTitle>{t('MicrosoftAccount.LoginFailedTitle')}</AlertTitle>
                        {t(loginFailure.notRegistered ? 'MicrosoftAccount.NotRegistered' : 'MicrosoftAccount.LoginFailed', values)}
                        {loginFailure.detail && (
                            <Typography variant='caption' component='div' sx={{ marginTop: '8px', opacity: 0.8 }}>
                                {t('MicrosoftAccount.ErrorCode', { code: loginFailure.detail })}
                            </Typography>
                        )}
                    </Alert>
                    <Button variant='contained' fullWidth disabled={switchingAccount} sx={{ marginTop: '16px' }} onClick={signInWithAnotherAccount}>
                        {t('MicrosoftAccount.UseAnotherAccount')}
                    </Button>
                    <Button variant='outlined' fullWidth disabled={switchingAccount} sx={{ marginTop: '8px' }} onClick={() => navigate(getMicrosoftLoginPage())}>
                        {t('MicrosoftAccount.BackToLogin')}
                    </Button>
                </Box>
            </Box>
        );
    }

    return (
        <div>
            <div>
                <CircularProgress />
            </div>

            <ChooseTenantDialog isOpen={dialogOpen} onClose={(r) => { setDialogOpen(false); if (r) { loginMS(accessTokenMS!, msAccount!, r, state ? state.name : undefined); } }} />

            <Snackbar open={loginError !== ""} autoHideDuration={3000} onClose={() => setLoginError("")}>

                <Alert onClose={() => setLoginError("")} severity="error" sx={{ width: '100%' }}>
                    Přihlášení se nezdařilo: {loginError}
                </Alert>

            </Snackbar>
        </div>

    );
}
